/**
 * Constants for Admin Frontend Service
 */

// Time intervals (in milliseconds)
export const SERVICE_HEALTH_REFRESH_INTERVAL = 30000 // 30 seconds
export const TOAST_DURATION = 3000 // 3 seconds
export const REQUEST_TIMEOUT = 30000 // 30 seconds

// API Configuration
export const API_VERSION = 'v1'
export const DEFAULT_PAGE_SIZE = 50
export const MAX_PAGE_SIZE = 100

// Service Status
export const ServiceStatus = {
  HEALTHY: 'healthy',
  DEGRADED: 'degraded',
  DOWN: 'down'
}

// User Status
export const UserStatus = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  ACTIVE: 'active',
  INACTIVE: 'inactive'
}

// Feature Flag Target Audiences
export const TargetAudience = {
  BETA: 'beta',
  INTERNAL: 'internal',
  ALL: 'all',
  PREMIUM: 'premium'
}

// News Article Status
export const ArticleStatus = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived'
}

// Feedback Status
export const FeedbackStatus = {
  OPEN: 'open',
  IN_PROGRESS: 'in_progress',
  RESOLVED: 'resolved',
  CLOSED: 'closed'
}

// Critical Services
export const CRITICAL_SERVICES = [
  'mcp_orchestrator',
  'auth_service',
  'notification_service',
  'medication_data_service',
  'llm_service',
  'api_service'
]

// Service Registry (should be fetched from backend ideally)
export const SERVICE_REGISTRY = {
  mcp_orchestrator: { port: 8003, critical: true },
  auth_service: { port: 8002, critical: true },
  portal_api_service: { port: 8034, critical: true },
  admin_frontend_service: { port: 8022, critical: false },
  notification_service: { port: 8005, critical: true },
  medication_data_service: { port: 8006, critical: true },
  llm_service: { port: 8031, critical: true },
  api_service: { port: 8000, critical: true },
  sync_service: { port: 8004, critical: false },
  personalization_service: { port: 8008, critical: false },
  feedback_service: { port: 8009, critical: false },
  feedback_analysis_service: { port: 8010, critical: false },
  conversation_memory_service: { port: 8023, critical: false },
  analytics_service: { port: 8025, critical: false },
  medical_dictionary_service: { port: 8026, critical: false },
  health_monitoring_service: { port: 8027, critical: false },
  appointment_service: { port: 8028, critical: false },
  emergency_service: { port: 8029, critical: false },
  vault_service: { port: 8030, critical: false },
  prompt_service: { port: 8032, critical: false },
  rxnav_adapter: { port: 8033, critical: false },
  asr_service: { port: 8001, critical: false }
}

// Chart Colors
export const ChartColors = {
  PRIMARY: '#1976d2',
  SUCCESS: '#4caf50',
  WARNING: '#ff9800',
  ERROR: '#f44336',
  INFO: '#2196f3'
}

// Messages
export const Messages = {
  LOGIN_SUCCESS: 'Login successful',
  LOGIN_FAILED: 'Invalid credentials',
  LOGOUT_SUCCESS: 'Logged out successfully',
  SESSION_EXPIRED: 'Session expired. Please login again.',
  NETWORK_ERROR: 'Network error. Please try again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  SAVE_SUCCESS: 'Saved successfully',
  DELETE_SUCCESS: 'Deleted successfully',
  UPDATE_SUCCESS: 'Updated successfully',
  PERMISSION_DENIED: 'You do not have permission to perform this action'
}